import styled from 'styled-components';
import { BlackButton } from '../../../baseComponents/button';
import { TypographyStyles, colours, focusOutline, fontWeights, spacing } from '../../../stylings';

export const Wrapper = styled.div`
  margin-top: ${spacing.S};
`;

export const Item = styled.div<{ $isMiniCart: boolean }>`
  align-items: flex-start;
  border: solid ${colours.ADDONS_BORDER};
  border-width: ${({ $isMiniCart }) => ($isMiniCart ? '1px 0 0 0' : '1px 1px 0 1px')};
  display: flex;
  flex-direction: column;
  margin: 0;
  max-width: 700px;
  padding: 10px;

  &:last-of-type {
    border-width: ${({ $isMiniCart }) => ($isMiniCart ? '1px 0 0 0' : '1px')};
  }

  @media screen and (min-width: 400px) {
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

export const ImageWrapper = styled.a<{ $isMiniCart: boolean }>`
  aspect-ratio: 1/1;
  margin-bottom: ${({ $isMiniCart }) => ($isMiniCart ? '0' : '10px')};
  position: relative;
  width: 30%;

  @media (max-width: 998px) {
    margin: 0;
    min-width: 150px;
  }

  & div img {
    max-width: 203px;
    width: 100%;
  }
`;

export const Info = styled.div`
  color: ${colours.BLACK};
  flex-basis: 60%;
  flex-grow: 1;
  padding: 10px;
`;

export const StyledAnchor = styled.a`
  color: inherit;
  display: inline-block;
  text-decoration: none;

  :hover,
  :focus {
    cursor: pointer;
    text-decoration: underline;
  }
`;

export const Title = styled.h2`
  font-size: 16px;
`;

export const Price = styled.span`
  display: block;
  font-size: 16px;
  ${fontWeights.SemiBold600}
  margin-bottom: 10px;
`;

export const Description = styled.div`
  p {
    font-size: 14px;
  }
  h2 {
    font-size: 16px;
  }

  h3 {
    @media screen and (min-width: 768px) {
      font-size: 2.2rem;
      ${fontWeights.Regular400}
    }
  }

  ul {
    padding: 0 0 0 20px;
  }
`;

export const AddToBagWrapper = styled.div`
  margin: 0 auto;
  max-width: 250px;
  width: 100%;

  @media (max-width: 998px) {
    margin: 10px auto;
    max-width: 280px;
  }
`;

export const AddToBag = styled(BlackButton)`
  margin: 0px;
  width: 100%;

  &:disabled {
    cursor: not-allowed;
  }
`;
export const ErrorMessage = styled.p`
  color: ${colours.ERROR_PRIMARY};
  margin-bottom: 0;
  ${TypographyStyles.Body.Tiny.SemiBold}
`;
